module.exports = __webpack_public_path__ + "static/media/loadingMilkyway.ea27ac27.gif";